import React from 'react';

import './mappage.scss';

import Footer from '../../components/Footer/Footer';
import { useLanguage } from '../../LanguageContext';
import { Helmet } from 'react-helmet';

import MapArtworkComponent from '../../components/MapArtwork/MapArtwork';

function MapPage() {
  const { selectedLanguage } = useLanguage();

  return (
    <>
      <Helmet>
        {/* Titolo */}
        <title>{selectedLanguage === 'it' ? 'Bisanzio Svelata - Mappa' : 'Bisanzio Svelata - Map'}</title>

        {/* Meta Tags */}
        <meta name="description" content="Esplora i segreti di Bisanzio con Bisanzio Svelata - un progetto di ricerca dedicato a svelare i misteri dell'Impero Bizantino." />
        <meta name="keywords" content="Bisanzio, Bisanzio Svelata, progetto di ricerca, storia, misteri, Impero Bizantino" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Bisanzio Svelata - Mappa" />
        <meta property="og:description" content="Esplora i segreti di Bisanzio con Bisanzio Svelata - un progetto di ricerca dedicato a svelare i misteri dell'Impero Bizantino." />
        <meta property="og:image" content="https://www.bisanziosvelata.it/bisanziosvelata.png" />
        <meta property="og:url" content="https://www.bisanziosvelata.it/map" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta property="twitter:title" content="Bisanzio Svelata - Mappa" />
        <meta property="twitter:description" content="Esplora i segreti di Bisanzio con Bisanzio Svelata - un progetto di ricerca dedicato a svelare i misteri dell'Impero Bizantino." />
        <meta property="twitter:image" content="https://www.bisanziosvelata.it/bisanziosvelata.png" />
        <meta property="twitter:url" content="https://www.bisanziosvelata.it/map" />

        {/* URL Canonico */}
        <link rel="canonical" href="https://www.bisanziosvelata.it/map" />
      </Helmet>

      {/* La mappa E' la pagina: niente titolo, descrizione o spazi bianchi */}
      <MapArtworkComponent />
      <Footer />
    </>
  );
}

export default MapPage;
